export default __webpack_public_path__ + "static/media/squarespace.0848a42b.svg";